module.exports = __webpack_public_path__ + "img/pinjia5.4e0ebdac.jpg";